import cloneDeep from 'lodash/cloneDeep'
import {
  SET_INITIAL_FILTER_INFO,
  SET_CURRENT_FILTER_INFO,
  UPDATE_EXACT_DATE_FILTERS_UI
} from '../../../actions/actionTypes'

/* DATES */
export const altDatesFilter = (state = [], action) => {
  const { type, payload } = action

  switch (type) {
    case SET_INITIAL_FILTER_INFO:
      return (payload.DATE && payload.DATE.map(slice => ({ ...slice }))) || []

    case SET_CURRENT_FILTER_INFO:
      return payload.altDatesFilter.map(slice => ({ ...slice }))

    case UPDATE_EXACT_DATE_FILTERS_UI:
      const [dateKey, dateKeyValue] = payload
      return cloneDeep(state).map(date => {
        if (date.value === dateKey) {
          date.checked = dateKeyValue
        }
        return { ...date }
      })

    default:
      return state
  }
}
